export * from './content-switch';

//# sourceMappingURL=index.js.map